export default {
    settings: {
        loadFailed: 'Failed to load bol.com settings.',
        saved: 'bol.com settings saved.',
        saveFailed: 'Failed to save bol.com settings.',
        fulfilmentFbr: 'FBR: you ship (Fulfilment by Retailer)',
        fulfilmentFbb: 'FBB: bol ships (Fulfilment by bol)',
    },
    connection: {
        title: 'bol.com connection',
        intro: "Connect a bol.com Retailer API account to push stock and pull in orders. Credentials come from the bol.com seller dashboard (Settings → API). Products are matched to bol offers by SKU (your SKU is the product's EAN).",
        clientId: 'Client ID',
        clientIdPlaceholder: 'bol.com API client id',
        clientSecret: 'Client secret',
        secretSavedPlaceholder: '•••••••• (saved, leave blank to keep)',
        secretPlaceholder: 'bol.com API client secret',
        secretHint: 'Stored securely and never shown again. Leave blank to keep the current secret.',
        fulfilmentMethod: 'Fulfilment method',
        test: 'Test connection',
        saveFirst: 'Save the credentials first.',
        testOk: 'Connected to bol.com: the credentials are valid.',
        testRejected: 'bol.com rejected the credentials.',
        testUnreachable: 'Failed to reach bol.com.',
    },
    sync: {
        title: 'Sync',
        pushStock: 'Push stock to bol.com',
        pushStockHelp: "Send your available stock levels up to bol offers so they don't oversell.",
        pullOrders: 'Pull orders from bol.com',
        pullOrdersHelp: 'Import bol orders so you fulfil them alongside your own.',
        nothingDispatched: 'Nothing dispatched. Enable the matching sync toggle first.',
        queued: 'Sync queued ({directions}). Runs in the background.',
        queueFailed: 'Failed to queue the sync.',
    },
    direction: {
        stock: 'stock',
        orders: 'orders',
        both: 'stock and orders',
    },
    status: {
        lastStockSync: 'Last stock sync',
        lastOrderSync: 'Last order sync',
        lastStatus: 'Last status',
        never: 'never',
    },
    verify: {
        title: 'Sync & verify',
        intro: 'Run a sync now, or do a dry-run first to see exactly what would change (in the CMS and on bol.com) before anything is written.',
        syncStock: 'Sync stock now',
        pullOrders: 'Pull orders now',
        syncBoth: 'Sync both',
    },
    dryRun: {
        title: 'Dry-run',
        help: 'Read-only. Reads bol.com offers and open orders; writes nothing.',
        run: 'Run dry-run',
        running: 'Running…',
        startFailed: 'Failed to start the dry-run.',
        computing: 'Computing the diff against bol.com…',
        failed: 'The dry-run failed.',
        stockUpdates: 'no stock updates | {n} stock update | {n} stock updates',
        orderImports: 'no orders to import | {n} order to import | {n} orders to import',
        warnings: 'no warnings | {n} warning | {n} warnings',
        computedAt: 'computed {date}',
        stockTitle: 'Stock pushes (CMS → bol)',
        bolOffer: 'bol offer',
        from: 'From',
        to: 'To',
        noStockChanges: 'No stock changes: bol is already in sync.',
        ordersTitle: 'Orders to import (bol → CMS)',
        bolOrder: 'bol order',
        items: 'Items',
        match: 'Match',
        allMatched: 'all matched',
        unmatched: '{n} unmatched',
        noOrders: 'No new orders to import.',
    },
};
